import React from 'react'
import { Col, Collapse, Row, Modal, Icon, Tooltip } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

// Components
import Container from "../../../../../containers/Container";
import Api_tnn from "../../../../../api/api.tnn";
import Message from "../../../../../components/Messages";
import message from "../../../../../components/Messages";
import MESSAGE from "../../../../../components/Messages";
import helper from '../../../../../helper/helper'
import typo from '../../../../../constants/dictionaries'
import columns from './BCDK.column'
import Table from '../../../../../components/Table'
import Api_dms from "../../../../../api/api.dms";
import BCDKModal from '../BaoCaoDinhKy/Modal/index'
import { isEmpty } from 'lodash'
import { functionsCode } from '../../../../../constants/constant'
import Button from "../../../../../components/Buttons";

const { Panel } = Collapse;

class BaoCaoDK extends React.Component {
    constructor(props) {
        super(props);
        const { functions } = props;
        this.state = {
            data: [],
            mode: 'add',
            isShowEditModal: false,
            isShowAddModal: false,
            selectedRow: null,
            editable: !isEmpty(functions) ? helper.handleGetEditableFunction(functions, functionsCode.TNN_XT).editable : false,
            pagination: {
                PageNumber: 1,
                PageSize: 10,
                Total: 0
            },
        }
    }

    componentDidMount() {
        const { idGiayPhep } = this.props;
        const { pagination } = this.state
        idGiayPhep && this.getGiayPhepCTById(pagination.PageNumber, pagination.PageSize)
    }

    getGiayPhepCTById = (page, size) => {
        const { idGiayPhep } = this.props;
        new Api_tnn().GetBCDK_By_GiayPhep({ token: this.props.user.access_token, IdGiayPhep: idGiayPhep, page: page, size: size })
            .then(res => {
                this.setState({
                    data: res && res.data,
                    pagination: {
                        PageNumber: res && res.pagination && res.pagination.currentPage,
                        PageSize: size,
                        Total: res && res.pagination && res.pagination.total
                    },
                })
            })
            .catch(err => {
                Message.error(err.message)
            })
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { pagination } = this.state
        if (prevProps.idGiayPhep !== this.props.idGiayPhep) {
            this.getGiayPhepCTById(pagination.PageNumber, pagination.PageSize)
        }
        if (prevProps !== this.props) {
            const { functions } = this.props;
            if (!isEmpty(functions)) {
                const func = helper.handleGetEditableFunction(functions, functionsCode.TNN_XT);
                this.setState({ editable: func.editable })
            }
        }
        
    }
    showEditModal = (selectedRow, name) => {
        this.setState({ mode: name })
        this.GetDoanhNgiep_BaoCao(selectedRow.id)
    };
    GetDoanhNgiep_BaoCao = (id) => {
        return new Api_tnn()
            .GetDoanhNgiep_BaoCao({
                token: this.props.user.access_token,
                id: id,
            })
            .then((res) => {
                this.setState({
                    isShowEditModal: true,
                    selectedRow: res,
                });
            }).catch(err => {
                message.error(err.message)
            });
    };


    showFile = (item) => {
        if (item.fileDinhKems !== undefined || item.fileDinhKems !== []) {
            if (item.fileDinhKems.length > 1) {
                this.setState({
                    setModal: true,
                    selectdFile: item.fileDinhKems
                })
            } else {
                this.downFile(item.fileDinhKems[0])
            }
        }
    }
    downFile = (data) => {
        if (data === undefined || data === []) {
            message.warning(MESSAGE.CSCORE_KHONG_CO_FILE)
        } else {
            new Api_dms().DownloadFile({
                token: this.props.user.access_token,
                data: { oid: data.idFile, filename: data.tenTaiLieu }
            })
        }
    }
    handleCancel = () => {
        this.setState({
            isShowEditModal: false,
            isShowAddModal: false
        });
    };
    DeleteDoanhNgiep_BaoCao = (id) => {
        const {pagination} =this.state
        new Api_tnn()
          .DeleteDoanhNgiep_BaoCao({
            token: this.props.user.access_token,
            id: id,
          })
          .then(res => {
            message.success("Xóa thành công");
            this.getGiayPhepCTById(pagination.PageNumber, pagination.PageSize)
          }).catch(err => {
            message.error(err.message)
          });
      };

    showDeleteConfirm = (selectedRow) => {
        this.DeleteDoanhNgiep_BaoCao(selectedRow.id)
      }
    handleAdd = () => {
        const { pagination } = this.state
        this.getGiayPhepCTById(pagination.PageNumber, pagination.PageSize)
        this.handleCancel();
    };
    handleTableParamsChange = (pagination, filteredInfo, sortedInfo) => {
        this.getGiayPhepCTById(pagination.current, pagination.pageSize)
    };
    showAddModal = () => {
        this.setState({
            isShowAddModal: true,
        });
    };
    render() {
        const { data_giayphep, user, editable } = this.props;
        const { data, mode, isShowEditModal, selectedRow, pagination, isShowAddModal } = this.state;
        const tableColumns = columns({
            showEditModal: this.showEditModal,
            showFile: this.showFile,
            showViewModal: this.showEditModal,
            deleteRow: this.showDeleteConfirm,
            editable
        })

        return (
            <Container>
                {editable &&
                <Row type='flex' justify='end' style={{ marginBottom: 10}}>
                    <Tooltip title="Thêm mới" placement="top">
                        <Button type="primary" onClick={this.showAddModal}>
                            <Icon type="plus" />
                        </Button>
                    </Tooltip>
                </Row>}
                {data.length > 0 ?
                    <Table
                        columns={tableColumns}
                        dataSource={helper.addSttToDataSource(data)}
                        onChange={this.handleTableParamsChange}
                        hideTotal="true"
                        pagination={{
                            total: pagination.Total,
                            pageSize: pagination.PageSize,
                            current: pagination.PageNumber
                        }}
                    />
                    : <div style={{ color: "#cfcdcd", textAlign: "center" }}>
                        Không có báo cáo định kỳ
                          </div>
                }
                {isShowEditModal &&
                    <Modal
                        title={mode === "view" ? typo.cscore_thong_tin_chi_tiet : typo.cscore_edit_bao_cao}
                        centered
                        closable={true}
                        visible={isShowEditModal}
                        width="750px"
                        footer={null}
                        onCancel={this.handleCancel}
                        maskClosable={false}
                    >
                        <BCDKModal
                            handleAdd={this.handleAdd}
                            handleCloseModal={this.handleCancel}
                            selectedRow={selectedRow}
                            isEdit={true}
                            user={user}
                            mode={mode}
                        />
                    </Modal>
                }
                {isShowAddModal &&
                    <Modal
                        title={typo.cscore_add_bao_cao}
                        centered
                        closable={true}
                        visible={isShowAddModal}
                        width="750px"
                        footer={null}
                        onCancel={this.handleCancel}
                        maskClosable={false}
                    >
                        <BCDKModal
                            handleCloseModal={this.handleCancel}
                            handleAdd={this.handleAdd}
                            selectedRow={data_giayphep}
                            user={user}
                        />
                    </Modal>
                }
            </Container>
        )
    }
}

BaoCaoDK.propTypes = {
    idGiayPhep: PropTypes.string
};


const mapStateToProps = (state) => ({
    user: state.oidc.user
});

export default connect(mapStateToProps)(BaoCaoDK)